export default __webpack_public_path__ + "static/media/slide01.48c8fcc7.jpg";